import { N5111OutHaisorutoData } from "../n511/n5111-detail-data";
import { CommonBaseData } from "../shared/data/common-base-data";
import { N511A01OutData } from "../shared/webapi-data/n501a01-out-data";

export class N5111OutputData extends CommonBaseData  {

  public apiOutData: N511A01OutData;

  // 明細データ
  public detailData: N5111OutHaisorutoData[];

}



// WEBPACK FOOTER //
// ./src/app/modules/n511/n5111-output-data.ts